import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAllExternalUsers() {
  const response = await $.soap({
    body: {
      GetAllExternalUsers: {
        $xmlns: 'http://dla.mil/ems/bpm/user'
      }
    },
    blueprintArrays: ['GetAllExternalUsersResponse.Response.ExternalUser'],
    blueprint: {
      users: [
        'GetAllExternalUsersResponse.Response.ExternalUser',
        {
          id: '$..ID',
          otdsUserId: '$..OTDSUserID',
          firstName: '$..FirstName',
          lastName: '$..LastName',
          email: '$..Email',
          isCac: '$..IsCACLogin',
          orgUnit: '$..OrgUnit',
          actingAsCommandId: '$..ActingAsCommandID',
          isAuthorized: '$..IsAuthorized',
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.users;
}